import React from 'react';
type PageIntroProps = {
  eyebrow: string;
  title: React.ReactNode;
  intro: React.ReactNode;
  image?: {
    src: string;
    alt: string;
    position?: string;
  };
  children?: React.ReactNode;
};
export function PageIntro({
  eyebrow,
  title,
  intro,
  image,
  children
}: PageIntroProps) {
  return <section className="w-full border-b border-line bg-ink pt-16 md:pt-20" data-id="element-253" data-mp="3svotcyoqq095">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 pb-16 pt-12 md:px-10 lg:grid-cols-12 lg:items-end lg:gap-10 lg:pb-20 lg:pt-20" data-id="element-254" data-mp="3stm4wj38kf6j">
        <div className={image ? 'lg:col-span-7' : 'lg:col-span-10'} data-id="element-255" data-mp="307sz00mn8kfj">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-amber" data-id="element-256" data-mp="3eve1bsbp2fme">
            <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-257" data-mp="3a4fh4hnl4xdv" />
            {eyebrow}
          </p>
          <h1 className="mt-6 font-serif text-6xl leading-[0.95] tracking-tight text-paper md:text-7xl xl:text-8xl" data-id="element-258" data-mp="2mela4gpy631j">
            {title}
          </h1>
          <div className="mt-8 max-w-xl text-lg leading-relaxed text-sand" data-id="element-259" data-mp="2heflzaivyyo7">{intro}</div>
          {children && <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-260" data-mp="1gvhs6npd43o1">{children}</div>}
        </div>
        {image && <figure className="relative lg:col-span-4 lg:col-start-9" data-id="element-261" data-mp="1qndte7mqw9wh">
            <span aria-hidden className="absolute -top-2.5 left-3 h-full w-full rounded-md border border-amber-deep" data-id="element-262" data-mp="1qp8epn1xi413" />
            <img src={image.src} alt={image.alt} style={{
          objectPosition: image.position ?? '50% 50%'
        }} className="relative aspect-[4/5] w-full rounded object-cover" data-id="element-263" data-mp="xygbi5mg4f49" />
          </figure>}
      </div>
    </section>;
}